module.exports = __webpack_public_path__ + "img/main.eb05d474.png";